import React from 'react';

import loadingGif from '../../assets/images/loading.gif';

import { Box } from './styles';

function Loading() {
  return (
    <Box>
      <img alt="loading" src={loadingGif} />
    </Box>
  );
}

export default Loading;
